var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-slider',{staticClass:"slider",attrs:{"value":_vm.value,"tick-size":_vm.tickSize,"min":_vm.min,"max":_vm.max,"step":_vm.step,"thumb-color":"white"},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }